<ng-container *ngIf="sharedLinkId">
  <adf-alfresco-viewer [allowPrint]="false" [allowDownload]="false" [allowFullScreen]="false" [sharedLinkId]="sharedLinkId" [allowGoBack]="false">
    <adf-viewer-toolbar-actions>
      <aca-toolbar [items]="viewerToolbarActions"></aca-toolbar>
    </adf-viewer-toolbar-actions>
  </adf-alfresco-viewer>
</ng-container>
